var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin } from '@capacitor/core';
export class KeyboardNubeWeb extends WebPlugin {
    setToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return { results: params.token };
        });
    }
    setLocale(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return { results: params.locale };
        });
    }
}
import { registerPlugin } from '@capacitor/core';
const KeyboardNube = registerPlugin('KeyboardNube', {
    web: () => new KeyboardNubeWeb(),
});
export { KeyboardNube };
//# sourceMappingURL=web.js.map